module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ff2e5ecc2ff301980e18fb74ac72187c.png";